<template>
  <form-layout :label="label">
    <input type="text" class="form-control" :class="errorMessage ? 'is-invalid' : ''" v-model="value" :maxlength="maxLength">
    <div class="invalid-feedback">{{ errorMessage }}</div>
  </form-layout>
</template>

<script>
import BaseVuexSearchItem from '@/views/molecules/searchItems/BaseVuexSearchItem';
import FormLayout from "@/views/templates/FormLayout";

export default {
  name: "VuexTextSearchItem",
  extends: BaseVuexSearchItem,
  props: {
    label: {
      type: String,
      required: true
    },
    maxLength: {
      type: Number,
      default: 100,
    },
  },
  components: {
    FormLayout
  },
}
</script>
